import { useEffect } from 'react';

export function useKeyboardNav(
  currentPage: number,
  totalPages: number,
  onPageChange: (page: number) => void,
  onToggleEdit?: () => void,
  onTogglePageList?: () => void,
  isPageListOpen?: boolean,
  onThumbnailSizeChange?: (size: 'small' | 'medium' | 'large') => void
) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // テキスト入力中はショートカットを無効化
      const target = e.target as HTMLElement;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return;
      }

      // ページ一覧が開いているときの専用キー操作
      if (isPageListOpen) {
        if (e.key === 'Enter') {
          onTogglePageList?.();
          return;
        } else if (e.key === '1') {
          onThumbnailSizeChange?.('small');
          return;
        } else if (e.key === '2') {
          onThumbnailSizeChange?.('medium');
          return;
        } else if (e.key === '3') {
          onThumbnailSizeChange?.('large');
          return;
        }
      }

      // 日本語漫画用: 右から左に読むため、矢印キーを逆転
      if (e.key === 'ArrowLeft' && currentPage < totalPages) {
        onPageChange(currentPage + 1);  // 次のページへ（日本語では「進む」）
      } else if (e.key === 'ArrowRight' && currentPage > 1) {
        onPageChange(currentPage - 1);  // 前のページへ（日本語では「戻る」）
      } else if (e.key === ' ') {
        e.preventDefault(); // ページスクロールを防止
        if (e.shiftKey) {
          if (currentPage > 1) onPageChange(currentPage - 1); // 前のページへ
        } else {
          if (currentPage < totalPages) onPageChange(currentPage + 1); // 次のページへ
        }
      } else if (e.key === 'PageUp') {
        // 5ページ前へ（日本語では「戻る」）
        const newPage = Math.max(1, currentPage - 5);
        onPageChange(newPage);
      } else if (e.key === 'PageDown') {
        // 5ページ次へ（日本語では「進む」）
        const newPage = Math.min(totalPages, currentPage + 5);
        onPageChange(newPage);
      } else if (e.key === 'Home') {
        onPageChange(1);
      } else if (e.key === 'End') {
        onPageChange(totalPages);
      } else if (e.key === 'Escape') {
        // リストに戻る
        window.history.back();
      } else if (e.key === 'e' || e.key === 'E') {
        // 編集パネルをトグル
        onToggleEdit?.();
      } else if (e.key === 'p' || e.key === 'P') {
        // ページ一覧をトグル
        onTogglePageList?.();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [currentPage, totalPages, onPageChange, onToggleEdit, onTogglePageList, isPageListOpen, onThumbnailSizeChange]);
}
